import { useState } from "react";

export default function RexoroForexWebsite() {
  const [showModal, setShowModal] = useState(false);

  const handleWhatsApp = () => {
    const message = `Hello Rexoro Forex,%0AI want to start investing.`;
    window.open(`https://wa.me/919079083101?text=${message}`, "_blank");
  };

  return (
    <div className="min-h-screen bg-black text-white font-sans">
      {/* Navbar */}
      <header className="flex items-center justify-between px-8 py-5 border-b border-white/10 backdrop-blur-md sticky top-0 z-50 bg-black/70">
        <div>
          <h1 className="text-2xl font-bold tracking-wide">Rexoro Forex</h1>
          <p className="text-xs text-gray-400">
            Smart Trading & Investment Solutions
          </p>
        </div>

        <nav className="hidden md:flex gap-8 text-sm text-gray-300">
          <a href="#about" className="hover:text-white transition">
            About
          </a>
          <a href="#plans" className="hover:text-white transition">
            Investment Plans
          </a>
          <a href="#features" className="hover:text-white transition">
            Features
          </a>
          <a href="#contact" className="hover:text-white transition">
            Contact
          </a>
        </nav>

        <button className="bg-white text-black px-5 py-2 rounded-full font-semibold hover:scale-105 transition">
          Get Started
        </button>
      </header>

      {/* Hero Section */}
      <section className="relative overflow-hidden px-8 md:px-20 py-24 md:py-36">
        <div className="absolute top-0 left-0 w-96 h-96 bg-green-500/20 blur-3xl rounded-full"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-500/20 blur-3xl rounded-full"></div>

        <div className="relative z-10 max-w-6xl mx-auto grid md:grid-cols-2 gap-16 items-center">
          <div>
            <span className="inline-block px-4 py-1 rounded-full bg-white/10 border border-white/10 text-sm text-green-400 mb-6">
              Trusted Forex Investment Platform
            </span>

            <h2 className="text-5xl md:text-7xl font-extrabold leading-tight mb-6">
              Grow Your Capital With
              <span className="text-green-400"> Rexoro Forex</span>
            </h2>

            <p className="text-gray-400 text-lg leading-8 mb-8 max-w-xl">
              Modern forex investment solutions focused on disciplined trading,
              transparency, and monthly payout systems.
            </p>

            <div className="flex flex-wrap gap-4">
              <button
                onClick={() => setShowModal(true)}
                className="bg-green-400 text-black font-bold px-7 py-4 rounded-2xl hover:scale-105 transition"
              >
                Start Investing
              </button>

              <button className="border border-white/20 px-7 py-4 rounded-2xl hover:bg-white/10 transition">
                Learn More
              </button>
            </div>
          </div>

          <div>
            <div className="bg-white/5 border border-white/10 rounded-3xl p-8 backdrop-blur-xl shadow-2xl">
              <div className="flex justify-between items-center mb-8">
                <div>
                  <p className="text-gray-400 text-sm">
                    Estimated Monthly Return
                  </p>
                  <h3 className="text-4xl font-bold text-green-400">2% - 3%</h3>
                </div>

                <div className="w-16 h-16 rounded-2xl bg-green-400/20 flex items-center justify-center text-3xl">
                  📈
                </div>
              </div>

              <div className="space-y-5">
                <div className="bg-black/40 p-5 rounded-2xl border border-white/10 flex justify-between">
                  <span className="text-gray-400">Investment Range</span>
                  <span className="font-semibold">₹10,000+</span>
                </div>

                <div className="bg-black/40 p-5 rounded-2xl border border-white/10 flex justify-between">
                  <span className="text-gray-400">Monthly Payout</span>
                  <span className="font-semibold text-green-400">Regular</span>
                </div>

                <div className="bg-black/40 p-5 rounded-2xl border border-white/10 flex justify-between">
                  <span className="text-gray-400">Trading Markets</span>
                  <span className="font-semibold">Forex / Gold / Oil</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About */}
      <section
        id="about"
        className="px-8 md:px-20 py-24 bg-white/[0.02] border-y border-white/10"
      >
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16 items-center">
          <div>
            <h3 className="text-4xl font-bold mb-6">About Rexoro Forex</h3>
            <p className="text-gray-400 leading-8 text-lg">
              Rexoro Forex is a modern trading and investment startup focused on
              forex market opportunities and disciplined capital management. Our
              goal is to create a professional ecosystem where investors can
              participate in global financial markets with transparency and
              structured payout models.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-5">
            <div className="bg-white/5 p-6 rounded-3xl border border-white/10">
              <h4 className="text-3xl font-bold text-green-400 mb-2">24/7</h4>
              <p className="text-gray-400">Market Monitoring</p>
            </div>

            <div className="bg-white/5 p-6 rounded-3xl border border-white/10">
              <h4 className="text-3xl font-bold text-green-400 mb-2">100+</h4>
              <p className="text-gray-400">Investors</p>
            </div>

            <div className="bg-white/5 p-6 rounded-3xl border border-white/10">
              <h4 className="text-3xl font-bold text-green-400 mb-2">Forex</h4>
              <p className="text-gray-400">Gold & Oil Trading</p>
            </div>

            <div className="bg-white/5 p-6 rounded-3xl border border-white/10">
              <h4 className="text-3xl font-bold text-green-400 mb-2">Secure</h4>
              <p className="text-gray-400">Professional Process</p>
            </div>
          </div>
        </div>
      </section>

      {/* Plans */}
      <section id="plans" className="px-8 md:px-20 py-24">
        <div className="max-w-6xl mx-auto text-center mb-16">
          <h3 className="text-5xl font-bold mb-5">Investment Plans</h3>
          <p className="text-gray-400 text-lg">
            Flexible investment structure designed for different capital ranges.
          </p>
        </div>

        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10">
          <div className="bg-white/5 border border-white/10 rounded-[32px] p-10 hover:scale-[1.02] transition duration-300">
            <div className="mb-8">
              <p className="text-gray-400 mb-2">Standard Plan</p>
              <h4 className="text-5xl font-bold">2%</h4>
              <p className="text-gray-400 mt-2">Monthly Return Structure</p>
            </div>

            <ul className="space-y-4 text-gray-300">
              <li>✔ Investment below ₹1,00,000</li>
              <li>✔ Monthly payout system</li>
              <li>✔ Forex market participation</li>
              <li>✔ Transparent communication</li>
            </ul>

            <button className="w-full mt-10 bg-white text-black py-4 rounded-2xl font-bold hover:opacity-90">
              Choose Plan
            </button>
          </div>

          <div className="bg-gradient-to-b from-green-400/20 to-green-500/5 border border-green-400/30 rounded-[32px] p-10 hover:scale-[1.02] transition duration-300 relative overflow-hidden">
            <div className="absolute top-4 right-4 bg-green-400 text-black text-xs px-3 py-1 rounded-full font-bold">
              Popular
            </div>

            <div className="mb-8">
              <p className="text-gray-300 mb-2">Premium Plan</p>
              <h4 className="text-5xl font-bold text-green-400">3%</h4>
              <p className="text-gray-300 mt-2">Monthly Return Structure</p>
            </div>

            <ul className="space-y-4 text-gray-200">
              <li>✔ Investment ₹1,00,000 and above</li>
              <li>✔ Priority investor support</li>
              <li>✔ Monthly payout system</li>
              <li>✔ Diversified forex trading</li>
            </ul>

            <button className="w-full mt-10 bg-green-400 text-black py-4 rounded-2xl font-bold hover:opacity-90">
              Get Started
            </button>
          </div>
        </div>
      </section>

      {/* Features */}
      <section
        id="features"
        className="px-8 md:px-20 py-24 bg-white/[0.02] border-y border-white/10"
      >
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h3 className="text-5xl font-bold mb-5">Why Choose Us</h3>
            <p className="text-gray-400 text-lg">
              Modern investment experience with professional structure.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white/5 p-8 rounded-3xl border border-white/10">
              <div className="text-5xl mb-5">🔒</div>
              <h4 className="text-2xl font-bold mb-4">Secure Process</h4>
              <p className="text-gray-400 leading-7">
                Investor-focused onboarding and structured communication.
              </p>
            </div>

            <div className="bg-white/5 p-8 rounded-3xl border border-white/10">
              <div className="text-5xl mb-5">📊</div>
              <h4 className="text-2xl font-bold mb-4">Professional Trading</h4>
              <p className="text-gray-400 leading-7">
                Market analysis driven trading in forex, gold and oil.
              </p>
            </div>

            <div className="bg-white/5 p-8 rounded-3xl border border-white/10">
              <div className="text-5xl mb-5">💸</div>
              <h4 className="text-2xl font-bold mb-4">Monthly Payouts</h4>
              <p className="text-gray-400 leading-7">
                Structured monthly payout system for investors.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="px-8 md:px-20 py-24">
        <div className="max-w-5xl mx-auto bg-gradient-to-r from-green-500/20 to-blue-500/20 border border-white/10 rounded-[40px] p-12 text-center backdrop-blur-xl">
          <h3 className="text-5xl font-bold mb-6">
            Start Your Investment Journey Today
          </h3>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto leading-8 mb-10">
            Join Rexoro Forex and explore opportunities in the global forex
            market with a modern investment experience.
          </p>

          <button className="bg-green-400 text-black px-10 py-5 rounded-2xl font-bold text-lg hover:scale-105 transition">
            Contact Now
          </button>
        </div>
      </section>

      {/* Contact */}
      <section
        id="contact"
        className="px-8 md:px-20 py-20 border-t border-white/10"
      >
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16">
          <div>
            <h3 className="text-4xl font-bold mb-6">Contact Us</h3>
            <p className="text-gray-400 leading-8">
              Have questions about investment plans or partnership
              opportunities? Reach out to our team.
            </p>
          </div>

          <div className="space-y-5">
            <input
              type="text"
              placeholder="Your Name"
              className="w-full bg-white/5 border border-white/10 rounded-2xl px-5 py-4 outline-none"
            />

            <input
              type="email"
              placeholder="Your Email"
              className="w-full bg-white/5 border border-white/10 rounded-2xl px-5 py-4 outline-none"
            />

            <textarea
              rows="5"
              placeholder="Your Message"
              className="w-full bg-white/5 border border-white/10 rounded-2xl px-5 py-4 outline-none"
            ></textarea>

            <button className="bg-green-400 text-black px-8 py-4 rounded-2xl font-bold hover:scale-105 transition">
              Send Message
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="px-8 md:px-20 py-10 border-t border-white/10 text-center text-gray-500 text-sm">
        © 2026 Rexoro Forex. All rights reserved.
        <p className="mt-4 max-w-4xl mx-auto leading-7 text-xs text-gray-600">
          Disclaimer: Trading and investment activities involve market risks.
          Returns are not guaranteed and may vary depending on market
          conditions. Users should review applicable financial regulations and
          seek professional advice where necessary.
        </p>
      </footer>

      {/* Investment Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-md flex items-center justify-center z-50 p-5">
          <div className="bg-[#111] border border-white/10 rounded-[32px] p-8 w-full max-w-2xl relative shadow-2xl">
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-5 right-5 text-2xl text-gray-400 hover:text-white"
            >
              ✕
            </button>

            <div className="text-center mb-10">
              <h2 className="text-4xl font-bold mb-4">Start Investing</h2>

              <p className="text-gray-400 leading-7">
                Fill your details and our team will contact you shortly.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-5">
              <input
                type="text"
                placeholder="Full Name"
                className="bg-white/5 border border-white/10 rounded-2xl px-5 py-4 outline-none"
              />

              <input
                type="text"
                placeholder="Phone Number"
                className="bg-white/5 border border-white/10 rounded-2xl px-5 py-4 outline-none"
              />

              <input
                type="email"
                placeholder="Email Address"
                className="bg-white/5 border border-white/10 rounded-2xl px-5 py-4 outline-none"
              />

              <input
                type="text"
                placeholder="Investment Amount"
                className="bg-white/5 border border-white/10 rounded-2xl px-5 py-4 outline-none"
              />

              <select
                className="bg-[#141414] border border-white/10 rounded-2xl px-5 py-4 outline-none md:col-span-2 text-white focus:border-green-400 transition"
              >
                <option className="bg-[#141414] text-white">
                  Select Investment Plan
                </option>

                <option className="bg-[#141414] text-white">
                  2% Monthly Plan
                </option>

                <option className="bg-[#141414] text-white">
                  3% Monthly Plan
                </option>
              </select>

              <textarea
                rows="4"
                placeholder="Message"
                className="bg-white/5 border border-white/10 rounded-2xl px-5 py-4 outline-none md:col-span-2"
              ></textarea>
            </div>

            <div className="mt-8 flex flex-col md:flex-row gap-4">
              <button
                onClick={handleWhatsApp}
                className="flex-1 bg-green-400 text-black py-4 rounded-2xl font-bold text-lg hover:scale-[1.02] transition"
              >
                Continue on WhatsApp
              </button>

              <button
                onClick={() => setShowModal(false)}
                className="flex-1 border border-white/10 py-4 rounded-2xl font-semibold hover:bg-white/5"
              >
                Cancel
              </button>
            </div>

            <p className="text-center text-gray-500 text-sm mt-6 leading-7">
              Our team will contact you within 15 minutes.
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
